import {
  Attribute,
  ChangeDetectorRef,
  Component, inject,
  Injector,
  Optional
} from '@angular/core';
import { CommonModule, DatePipe } from "@angular/common";

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  provideAsWidgetRef,
  Parent,
  styler,
  register
} from "@wm/components-base";
import { getDateObj, getFormattedDate, runtimeEventManager } from "@wm/core";
import { BaseDateTimeComponent } from "../base-date-time.component";
import { getAppDefault } from '../utils/appDefaults';

const CURRENT_DATE = 'CURRENT_DATE';
const DEFAULT_CLS = "app-date input-group";

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-date',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmDate]',
  template: ` <input class="form-control app-textbox app-dateinput app-dateinput display-input"
                     type="{{loadNativeDateInput ? 'date':'text'}}"
                     [name]="name"
                     [value]="displayValue"
                     [disabled]="disabled || readonly"
                     [required]="required"
                     [readOnly]="isReadOnly">

  <span class="input-group-btn" *ngIf="!loadNativeDateInput">
        <button type="button"
                class="btn btn-default btn-time"
                [tabindex]="tabindex"
                [disabled]="disabled || readonly">
            <i aria-hidden="true"
               class="app-icon wm-sl-l sl-calendar"></i>
        </button>
    </span>`,
  providers: [
    provideAsWidgetRef(DateComponent), DatePipe
  ],
  exportAs: 'wmDate',
  standalone: true,
  imports: [CommonModule],
  styles: []
})
export class DateComponent extends BaseDateTimeComponent {
  static initializeProps = register('wm-date');
  public bsDataValue: any;
  public showdropdownon: string;
  public isOpen: boolean = false;
  public hint: string;
  private dateContainerCls: string;
  private isEnterPressedOnDateInput = false;
  private _bsDefaultLoadCheck: boolean;

  constructor(inj: Injector, @Optional() viewParent: Parent, @Attribute('datepattern') public _datepattern: string) {
    super(inj, WIDGET_CONFIG, viewParent);
    this.datePipe = inject(DatePipe);
    styler(this.nativeElement, this);
    this._dateOptions.containerClass = `app-date ${this.dateContainerCls}`;
    this._dateOptions.showWeekNumbers = false;
    this._bsDefaultLoadCheck = true;
  }

  override setAppDefaultForProp() {
    if (this._datepattern) {
      return;
    }
    let datepattern = getAppDefault('dateFormat');
    if (!datepattern) {
      runtimeEventManager.on('wms:app-defaults-ready').subscribe(() => {
        this.datepattern = getAppDefault('dateFormat');
        this.updateFormat('datepattern');
      });
      return;
    }
    this.datepattern = datepattern;
    this.updateFormat('datepattern');
  }

  get timestamp() {
    return this.bsDataValue ? this.bsDataValue.valueOf() : undefined;
  }

  get dateInputFormat() {
    return this._dateOptions.dateInputFormat || this.datepattern || 'yyyy-MM-dd';
  }

  get displayValue() {
    return getFormattedDate(this.datePipe, this.bsDataValue, this.dateInputFormat) || '';
  }

  get nativeDisplayValue() {
    return getFormattedDate(this.datePipe, this.bsDataValue, 'yyyy-MM-dd') || '';
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any): void {
    switch (key) {
      case 'datavalue': if (nv === CURRENT_DATE) {
        this.bsDataValue = new Date();
      } else {
        this.bsDataValue = nv ? getDateObj(nv, { isNativePicker: this.loadNativeDateInput }) : undefined;
      }
        break;
      case 'datepattern':
         this.datepattern = nv
         this.updateFormat('datepattern')
        break;
      default: super.onPropertyChange(key, nv, ov);
    }
  }
}



